import { render, staticRenderFns } from "./PartnershipMobileCard.vue?vue&type=template&id=42192547&"
import script from "./PartnershipMobileCard.vue?vue&type=script&lang=js&"
export * from "./PartnershipMobileCard.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipMobileCard.vue?vue&type=style&index=0&id=42192547&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports